<ion-icon name="{{icon}}" (click)="presentModal()"></ion-icon>